/**
 * Screen size enum values
 */
export enum ScreenSizeType {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop'
}
